import { render } from "./UniversalViewer.vue?vue&type=template&id=40f39ede&scoped=true"
import script from "./UniversalViewer.vue?vue&type=script&lang=js"
export * from "./UniversalViewer.vue?vue&type=script&lang=js"

import "./UniversalViewer.vue?vue&type=style&index=0&id=40f39ede&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dl-viewer/dl-viewer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f39ede"]])

export default __exports__